// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1CU7F","row":"styles_row__59ccN"};